/* eslint-disable @typescript-eslint/no-explicit-any */
export const ascending = <T>(a: T, b: T): number => (b < a ? 1 : b > a ? -1 : 0);

export const descending = <T>(a: T, b: T): number => (b < a ? -1 : b > a ? 1 : 0);

export const conditional = <T>(a: T, b: T, condition: (value: T) => boolean): number =>
  condition(a) ? (condition(b) ? 0 : -1) : condition(b) ? 1 : 0;
